<template>
  <div class="AddReferrerInfo">
    <QS-h4-title title="推荐人信息" />
    <el-form
      :model="publicInfo"
      label-width="140px"
      style="overflow: hidden;"
    >
      <!-- <column-box :column="3" label-width="150px"> -->
        <el-col :span="8">
          <el-form-item
            prop="recommender"
            :label="`推荐方${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="publicInfo.recommender"
              placeholder="请输入"
              clearable
              maxlength="64"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="recommenderBankCard"
            :label="`推荐方银行卡${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="publicInfo.recommenderBankCard"
              placeholder="请输入"
              clearable
              maxlength="64"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="recommenderOpenBank"
            :label="`推荐方开户行${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="publicInfo.recommenderOpenBank"
              placeholder="请输入"
              clearable
              maxlength="64"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="recommenderRewardAmount"
            :label="`推荐奖励金额${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="publicInfo.recommenderRewardAmount"
              placeholder="请输入"
              clearable
              maxlength="64"
            >
            </el-input>
          </el-form-item>
        </el-col>

      <!-- </column-box> -->
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    addFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    addFormData: {
      handler(val) {
        this.publicInfo = {
          recommender: val.recommender || '',
          recommenderBankCard: val.recommenderBankCard || '',
          recommenderOpenBank: val.recommenderOpenBank || '',
          recommenderRewardAmount: val.recommenderRewardAmount || '',
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      publicInfo: {
        recommender: '', // 推荐方
        recommenderBankCard: '', // 推荐方银行卡
        recommenderOpenBank: '', // 推荐方开户行
        recommenderRewardAmount: '', // 推荐奖励金额
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.AddReferrerInfo{

}
</style>
